<div class="build-context">
<div class="context-wrapper">
  <div id="wb-dtmd">
    <span>Version {{version}} <span>- {{angularTag}} {{hybrisTag}} <span *ngIf="node !== undefined">({{node}})</span></span></span>
  </div>
</div>
</div>
